import { Label } from '../../../components/ui/label';
import { Input } from '../../../components/ui/input';
import { Switch } from '../../../../components/ui/switch';
import MultiSelectDropdownNoCreate from '../../dropdowns/MultiSelectDropdownNoCreate';
import { DonorListConfigurationTabProps } from './types';

export default function DonorListConfiguration(props: DonorListConfigurationTabProps) {
  const { formData, updateFormData, availableForms, handleFieldFocus, isFieldInvalid } = props;

  const { elementName, connectedForms, donorListType, showAllSupportersAnonymous } = formData;

  const setConnectedForms = (forms: string[]) => {
    updateFormData('connectedForms', forms);
    handleFieldFocus('configuration-connectedForms');
  };

  return (
    <>
      {/* Element Name */}
      <div className="space-y-0">
        <Label
          htmlFor="element-name"
          className="font-inter text-base font-medium leading-6 text-ink-secondary"
        >
          Element Name
        </Label>
        <Input
          id="element-name"
          value={elementName}
          onChange={(e) => {
            updateFormData('elementName', e.target.value);
          }}
          onFocus={() => handleFieldFocus('configuration-elementName')}
          className={`h-[28px] flex-shrink-0 self-stretch ${
            isFieldInvalid('elementName') ? 'border-red-500' : ''
          }`}
        />
      </div>

      {/* Connected Form */}
      <div className="space-y-0">
        <Label className="font-inter text-base font-medium leading-6 text-ink-secondary">
          Connected Form
        </Label>
        <div>
          <MultiSelectDropdownNoCreate
            height={28}
            options={(availableForms || [])
              .sort((a, b) => a.formName.localeCompare(b.formName))
              .map((form) => ({
                value: form.formName,
                label: form.formName,
              }))}
            setItems={setConnectedForms}
            items={connectedForms}
            error={isFieldInvalid('connectedForms')}
          />
        </div>
      </div>

      {/* Enable Donor List */}
      <div className="flex flex-col gap-2 [&_label]:text-ink-secondary">
        <div className="flex gap-16">
          <button
            type="button"
            className="flex items-center gap-1"
            onClick={() => updateFormData('donorListType', 'RECENT_DONORS')}
          >
            <span
              className={`flex h-4 w-4 shrink-0 items-center justify-center rounded-full border-2 bg-white ${
                donorListType === 'RECENT_DONORS' ? 'border-sage' : 'border-edge'
              }`}
              aria-hidden
            >
              {donorListType === 'RECENT_DONORS' && (
                <span className="h-2 w-2 rounded-full bg-sage" />
              )}
            </span>
            <Label className="block font-inter text-sm font-medium leading-5">
              Recent Donors
            </Label>
          </button>
          <button
            type="button"
            className="flex items-center gap-1"
            onClick={() => updateFormData('donorListType', 'TOP_DONORS')}
          >
            <span
              className={`flex h-4 w-4 shrink-0 items-center justify-center rounded-full border-2 bg-white ${
                donorListType === 'TOP_DONORS' ? 'border-sage' : 'border-edge'
              }`}
              aria-hidden
            >
              {donorListType === 'TOP_DONORS' && (
                <span className="h-2 w-2 rounded-full bg-sage" />
              )}
            </span>
            <Label className="block font-inter text-sm font-medium leading-5">
              Top Donors
            </Label>
          </button>
        </div>
      </div>

      {/* Show all supporters as anonymous */}
      <div className="flex items-center gap-1 [&_label]:text-ink-secondary">
        <Switch
          checked={!!showAllSupportersAnonymous}
          onCheckedChange={(checked) =>
            updateFormData('showAllSupportersAnonymous', !!checked)
          }
        />
        <Label className="block font-inter text-sm font-medium leading-5">
          Show all donors as anonymous
        </Label>
      </div>
    </>
  );
}
